import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Loader from "../../shared/loader";

const Invoices = () => {
  const [partyData, setPartyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [billData, setBillData] = useState({});
  const [showDetail, setShowDetail] = useState(false);

  const getParty = () => {
    axios.post(API_URL.INVOICE_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          res.data.data.data.map(
            (item) => (item.date = moment(item.date).format("DD/MM/YYYY"))
          );
          setPartyData(res.data.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-right",
        });
      }
    );
  };

  const deleteParty = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Invoice No - " + row.invoice_no,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.INVOICE_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = partyData.filter((r) => r.id != row.id);
              setPartyData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-right",
            });
          }
        );
      }
    });
  };

  useEffect(() => {
    getParty();
  }, []);
  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <div className="d-flex align-items-center">
            <h5 className="me-1">Sales </h5>
            <small className="me-2">({partyData.length})</small>
          </div>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <Link
                  to={"/admin/invoice/add"}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Sales
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>ID</th>
                        <th style={{ width: "20%" }}>Name</th>
                        <th style={{ width: "20%" }}>Date</th>
                        <th style={{ width: "20%" }}>Qty</th>
                        <th style={{ width: "20%" }}>Status</th>
                        <th style={{ width: "15%" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {partyData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{row.id}</td>
                            <td>{row?.user?.name}</td>
                            <td>{row.date}</td>
                            <td>{row.total_qty}</td>
                            <td>
                              <span class={`badge ${row.status === 'Completed' && 'text-bg-success'} ${row.status === 'Cancelled' && 'text-bg-danger'} ${row.status === 'In Progress' && 'text-bg-primary'} `}>{row.status}</span>
                            </td>
                            <td className="d-flex justify-content-end align-items-center gap-3">
                              <a
                                title="Edit"
                                onClick={() => {
                                  setBillData(row);
                                  setShowDetail(true);
                                }}
                              >
                                <i
                                  className="fa fa-eye"
                                  style={{ color: "#00a1b1" }}
                                ></i>
                              </a>
                              <Link
                                title="Edit"
                                to={"/admin/invoice/view/" + row.id}
                              >
                                <i
                                  className="fa fa-print"
                                  style={{ color: "gray" }}
                                ></i>
                              </Link>
                              <Link
                                title="Edit"
                                to={"/admin/invoice/edit/" + row.id}
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                              <i
                                onClick={() => deleteParty(row)}
                                className="fa fa-trash-alt"
                              ></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal size={"xl"} show={showDetail} onHide={() => setShowDetail(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#000" }}>Proforma Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {billData && billData.user && (
            <div className="section-main border">
              <div className="invaddress">
                <div
                  className="col-8"
                  style={{
                    width: "60%",
                    padding: "0",
                  }}
                >
                  <div
                    className="down-height-auto f13 border-end"
                    style={{
                      padding: "5px 15px",
                      height: "100px",
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <td colSpan="3" className="f12">
                            <div
                              style={{
                                textTransform: "uppercase",
                                textAlign: "left",
                                color: "#000"
                              }}
                            >
                              Detail of Receiver
                            </div>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              width: "70px",
                              verticalAlign: "top",
                              position: "relative",
                              color: "#000"
                            }}
                          >
                            Name
                            <span style={{ position: "absolute", right: "0" }}>
                              :
                            </span>
                          </td>
                          <td colSpan="2" style={{ paddingLeft: "5px" }}>
                            <h6
                              className="party_name f14"
                              style={{
                                margin: "3px 0px",
                                fontWeight: "bold",
                                textAlign: "left",
                                color: "#000"
                              }}
                            >
                              {billData.user.name}
                            </h6>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "70px",
                              verticalAlign: "top",
                              position: "relative",
                              color: "#000"
                            }}
                          >
                            City
                            <span style={{ position: "absolute", right: "0" }}>
                              :
                            </span>
                          </td>
                          <td colSpan="2" style={{ paddingLeft: "5px", color: "#000" }}>
                            <span className="party_city">
                              {billData.user?.city_name ?? ""}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              width: "70px",
                              verticalAlign: "top",
                              position: "relative",
                              color: "#000"
                            }}
                          >
                            State
                            <span style={{ position: "absolute", right: "0" }}>
                              :
                            </span>
                          </td>
                          <td style={{ paddingLeft: "5px", color: "#000" }}>
                            <span className="party_state">
                              {billData.user?.state_name ?? ""}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className="col-4 f14"
                  style={{
                    width: "40%",
                    padding: "0",
                    maxWidth: "40%",
                  }}
                >
                  <div
                    style={{
                      padding: "5px 15px",
                    }}
                  >
                    <div style={{ padding: "2px 0" }}>
                      <span style={{ display: "inline-block", width: "120px", color: "#000" }}>
                        ID
                      </span>
                      &nbsp;:&nbsp;&nbsp;&nbsp;
                      <span className="bill_invdate" style={{ color: "#000" }}>{billData.id}</span>
                    </div>
                    <div style={{ padding: "2px 0" }}>
                      <span style={{ display: "inline-block", width: "120px", color: "#000" }}>
                        Date
                      </span>
                      &nbsp;:&nbsp;&nbsp;&nbsp;
                      <span className="bill_invdate" style={{ color: "#000" }}>{billData.date}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="terms">
                <div
                  className="col-8"
                  style={{
                    width: "60%",
                    padding: "0",
                  }}
                ></div>
              </div>
              <div className="">
                <div style={{ padding: "0px", fontSize: "13px" }}>
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            padding: "3px 5px",
                            width: "50px",
                            textAlign: "center",
                            color: "#000"
                          }}
                          className="border-top border-bottom border-end"
                        >
                          Sr.
                        </th>
                        <th
                          style={{
                            padding: "3px 5px",
                            textAlign: "left",
                            color: "#000"
                          }}
                          className="border-top border-bottom border-end"
                        >
                          Product
                        </th>
                        <th
                          style={{
                            padding: "3px 5px",
                            width: "80px",
                            textAlign: "center",
                            color: "#000"
                          }}
                          className="border-top border-bottom"
                        >
                          Qty
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {billData.items.map((item, key) => {
                        return (
                          <tr key={key}>
                            <td
                              className="no border-top border-end"
                              style={{
                                padding: "4px 0 0 0px",
                                textAlign: "center",
                                color: "#000"
                              }}
                            >
                              {key + 1}
                            </td>
                            <td
                              style={{
                                padding: "4px 0 0 5px",
                                textAlign: "left",
                                fontSize: "12px",
                                color: "#000"
                              }}
                              className="border-top border-end"
                            >
                              {item?.product?.name}{" "}
                              {item?.subproduct
                                ? " - " + item?.subproduct?.name
                                : ""}{" "}
                              {item?.subproduct && item?.subproduct?.size
                                ? " - " + item?.subproduct?.size?.name
                                : " - " + item?.product?.size?.name}
                            </td>
                            <td
                              style={{
                                padding: "4px 0 0 0px",
                                textAlign: "center",
                                fontSize: "12px",
                                color: "#000"
                              }}
                              className="border-top"
                            >
                              {item.qty}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td
                          colSpan="2"
                          style={{
                            textAlign: "right",
                            fontSize: "14px",
                            fontWeight: "bold",
                            paddingRight: "5px",
                            color: "#000"
                          }}
                          className="border-top"
                        >
                          Total :
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            color: "#000"
                          }}
                          className="border-top"
                        >
                          {billData.total_qty}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Invoices;
